export default "__VITE_PUBLIC_ASSET__3571e477__"